import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { useCreateCms } from "../hooks";
import { CmsForm } from "../components";

export const CreateCms: React.FC = () => {
  const navigate = useNavigate();

  const { form, submit, loading } = useCreateCms({
    defaultValues: {},
    onCompleted: () => {
      toast.success("Le CMS a été créé avec succès");
      navigate("/cms");
    },
  });

  return (
    <>
      <Header
        title="CMS"
        subtitle="Créer un nouveau CMS"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/cms`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Nouveau CMS" />
          <CmsForm loading={loading} submit={submit} form={form} />
        </div>
      </div>
    </>
  );
};
